export default "__VITE_ASSET__DhUMRbBP__"